// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"video-camera-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 5L1 19L16 19L16 5L1 5Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M23 5.99805L16 10.198V13.998L23 17.998V5.99805Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M11.5 12L7 15L7 9.00003L11.5 12Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M23 5.99805L16 10.198L16 13.998L23 17.998V5.99805Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M1 4.99805L1 18.998L16 18.998L16 4.99805L1 4.99805Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11.5 12L7 15L7 9L11.5 12Z","strokeWidth":"props.strokeWidth"}}]}]};

const VideoCamera2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera-2',
    ref,
    icon: element,
  },
));

VideoCamera2Icon.displayName = 'VideoCamera2Icon';

export default VideoCamera2Icon;
